<template>
  <span>
    <v-dialog v-model="dialog" persistent max-width="550">
      <template v-slot:activator="{ on: dialogTool }">
        <v-tooltip :disabled="!signer.firmado" top>
          <template v-slot:activator="{ on: tooltip }">
            <div v-on="tooltip" class="d-inline-block">
              <v-icon
                v-on="{...dialogTool, ...tooltip}"
                :small="small"
                :color="color"
                :disabled="signer.firmado"
                >{{ icon.delete }}</v-icon
              >
            </div>
          </template>
          <span>El firmante no puede ser eliminado debido a que ya realizó la firma del documento</span>
        </v-tooltip>
      </template>
      <v-card>
        <v-card-title class="headline">{{
          last? signerDeleteLastLabels.questionText : signerDeleteLabels.questionText
        }}</v-card-title>
        <v-card-text>{{
          last? signerDeleteLastLabels.descriptionText : signerDeleteLabels.descriptionText.replace('@', signer.nombreCompleto)
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            id="document_tab_firmantes__eliminar__btn_si"
            color="accent"
            text
            @click="onDeleteSigner"
            :loading="loading"
            >{{ last? signerDeleteLastLabels.positiveButtonText : signerDeleteLabels.positiveButtonText }}</v-btn
          >
          <v-btn
            id="document_tab_firmantes__eliminar__btn_no"
            color="red darken-1"
            text
            @click="dialog = false"
            :disabled="loading"
            >{{ last? signerDeleteLabels.negativeButtonText : signerDeleteLabels.negativeButtonText }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import {
  signersStoreData,
  signersStoreActions
} from '@/modules/signers/store/signersStoreHelpers'
import { pushNotification, messageErrorResponse } from '@/store/helpers'
import { mdiTrashCanOutline } from '@mdi/js'

export default {
  name: 'SignerDelete',
  props: {
    signer: { type: Object, required: true },
    small: { type: Boolean, default: false },
    color: { type: String, default: 'grey darken-1' },
    last: { type: Boolean, default: false}
  },
  data() {
    return {
      icon: {
        delete: mdiTrashCanOutline
      },
      dialog: false,
      loading: false
    }
  },
  computed: {
    ...signersStoreData
  },
  methods: {
    ...signersStoreActions,
    onDeleteSigner() {
      this.loading = true

      this.deleteSignerToDocument(this.signer)
        .then((response) => {
          let result = response.data
          if (result.data.signers[0].success) {
            this.dialog = false
            this.$emit('deleted', this.signer)
          } else {
            this.notificationError(result.data.signers[0])
          }
        })
        .catch(err => {
          this.notificationError(err.data.data.signers[0])
        })
        .finally(() => {
          this.loading = false
        })
    },
    notificationError(msg) {
      pushNotification(
        this.$store,
        messageErrorResponse(msg) || this.msgSignerServiceDeleteError,
        'error',
        'left',
        false,
        true
      )
    }
  }
}
</script>
